export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/idIcon.19b1e1c3.svg","height":19,"width":20,"blurWidth":0,"blurHeight":0};